import { DisplayableData } from 'entities-next/common'

import { CriteriaLogic } from './entities'

export const CHECK_CONFIG_RESOURCE_ID = 'checksConfig'

export type CriteriaConfig<DataType = CriteriaDataTypes> = DisplayableData & {
  readonly id: CriteriaLogic
  readonly dataType: DataType
  readonly config?: SelectConfig
  readonly deprecated?: boolean
}

export type SelectConfig = {
  readonly isMulti?: boolean
  readonly entity?: SelectEntities
}

export enum SelectEntities {
  location = 'location',
  standardLocation = 'standard-location',
  stage = 'stage',
  roundType = 'round-type',
  industry = 'industry',
  industrySector = 'industry-sector',
  industryEnabler = 'industry-enabler',
  industryBusinessModel = 'industry-business-model',
  company = 'company',
  school = 'school',
  organization = 'organization',
  person = 'person',
  referrer = 'referrer',
  corporate = 'corporate',
  founder = 'founder',
  investorLevel = 'investor-level',
}

export enum CriteriaDataTypes {
  select = 'select',
  advancedSelect = 'advanced-select',
  boolean = 'boolean',
  numeric = 'numeric',
  time = 'time',
  text = 'text',
  yearRangeSelect = 'year-range-select',
}
